import { render } from "./NewDonorQuestionnairePage.vue?vue&type=template&id=054175d8"
import script from "./NewDonorQuestionnairePage.vue?vue&type=script&lang=js"
export * from "./NewDonorQuestionnairePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__